module.exports = __webpack_public_path__ + "static/media/logo_davide_groppi.753f2f63.svg";